export const actionNames = {
  FETCH_COUNTRIES: 'TIME_ZONES:FETCH_COUNTRIES',
  FETCH_COUNTRIES_SUCCESS: 'TIME_ZONES:FETCH_COUNTRIES_SUCCESS',
  FETCH_COUNTRIES_FAILURE: 'TIME_ZONES:FETCH_COUNTRIES_FAILURE',
  FETCH_COUNTRIES_LOADED: 'TIME_ZONES:FETCH_COUNTRIES_LOADED',
}

export const fetchCountries = () => {
  return {
    type: actionNames.FETCH_COUNTRIES,
  }
}
